import { render } from "./ChangePassword.vue?vue&type=template&id=34f448cd"
import script from "./ChangePassword.vue?vue&type=script&lang=js"
export * from "./ChangePassword.vue?vue&type=script&lang=js"
script.render = render

export default script